/* Layout only: no product data, availability, links, cart requests, or focus changes. */
(() => {
  const scope = '#ProductGridContainer';
  const cardSelector = '.wx-card-context-collection, .wx-card-context-search';
  const regions = [
    ['information', ':scope > .card > .card__content > .card__information'],
    ['selection', '.wx-card-purchase__selection'],
    ['price', '.wx-card-purchase__price-row'],
    ['unit', '.wx-card-purchase__unit-price-slot'],
    ['details', '.wx-card-purchase__details'],
    ['button', '.wx-card-purchase__button'],
  ];
  let frame = 0;
  let observedContainer;
  let previousWidth = -1;

  const alignRows = () => {
    frame = 0;
    const container = document.querySelector(scope);
    if (!container) return;
    observeWidth(container);
    const cards = [...container.querySelectorAll(cardSelector)];
    if (!cards.length) return;

    // Clear old dimensions together before measuring the current responsive layout.
    cards.forEach((card) => regions.forEach(([name]) => card.style.removeProperty(`--wx-row-${name}`)));
    const rows = [];
    cards.forEach((card) => {
      const item = card.closest('.grid__item');
      if (!item || !item.getClientRects().length) return;
      // Layout coordinates ignore staggered reveal-animation transforms.
      const top = item.offsetTop;
      let row = rows.find((entry) => Math.abs(entry.top - top) < 2);
      if (!row) rows.push(row = { top, cards: [] });
      row.cards.push(card);
    });

    // Measure all natural heights first. Each row only reserves the space it needs.
    const measurements = rows.map((row) => ({
      cards: row.cards,
      heights: regions.map(([name, selector]) => ({
        name,
        height: Math.ceil(Math.max(0, ...row.cards.map((card) => card.querySelector(selector)?.getBoundingClientRect().height || 0))),
      })),
    }));
    measurements.forEach(({ cards: rowCards, heights }) => {
      rowCards.forEach((card) => heights.forEach(({ name, height }) => card.style.setProperty(`--wx-row-${name}`, `${height}px`)));
    });
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(alignRows);
  };
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver((entries) => {
    const width = entries[0]?.contentRect.width;
    if (width === previousWidth) return;
    previousWidth = width;
    schedule();
  }) : null;
  const observeWidth = (container) => {
    if (container === observedContainer) return;
    resizeObserver?.disconnect();
    observedContainer = container;
    previousWidth = -1;
    resizeObserver?.observe(container);
  };

  const start = () => {
    const main = document.getElementById('MainContent') || document.querySelector(scope);
    if (!main || !document.querySelector(scope)) return;
    new MutationObserver((records) => {
      if (records.some((record) => record.target.closest?.(scope) || [...record.addedNodes, ...record.removedNodes]
        .some((node) => node.nodeType === 1 && (node.matches(scope) || node.querySelector(scope))))) schedule();
    }).observe(main, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', (event) => {
      if (event.target.closest(`${scope} .wx-card-purchase`)) schedule();
    });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener?.('loadingdone', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
